// extracted by mini-css-extract-plugin
export default {"emptyContainer":"emptyContainer---HiENC"};